import { render, staticRenderFns } from "./swiper.vue?vue&type=template&id=711e1e8f&"
import script from "./swiper.vue?vue&type=script&lang=js&"
export * from "./swiper.vue?vue&type=script&lang=js&"
import style0 from "./swiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('711e1e8f')) {
      api.createRecord('711e1e8f', component.options)
    } else {
      api.reload('711e1e8f', component.options)
    }
    module.hot.accept("./swiper.vue?vue&type=template&id=711e1e8f&", function () {
      api.rerender('711e1e8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/swiper/swiper.vue"
export default component.exports